export default __webpack_public_path__ + "static/media/Public Acts.dbbb77ec.pdf";